import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  PatronAddressModel,
  PatronModel,
  TransactionWrapper,
} from '@core/models';
import { PaymentDetails } from '../../models/payment-details.model';

@Component({
  selector: 'app-patron',
  imports: [CommonModule, FormsModule],
  templateUrl: './patron.component.html',
  styleUrl: './patron.component.css',
})
export class PatronComponent {
  @Input() patron: PatronModel;
  @Input() transaction: TransactionWrapper;
  @Input() paymentDetails: Omit<
    PaymentDetails,
    | 'paymentMethod'
    | 'cardType'
    | 'firstName'
    | 'lastName'
    | 'email'
    | 'address'
  > & {
    paymentMethod: string | null;
    cardType: string | null;
    firstName: string | null;
    lastName: string | null;
    email: string | null;
    address:
      | (Omit<PatronAddressModel, 'city' | 'postalCode' | 'address1'> & {
          city: string | null;
          postalCode: string | null;
          address1: string | null;
        })
      | null;
    phone: {
      phone: string;
      countryCode: string;
    } | null;
  } = {
    nonce: null,
    paymentMethod: null,
    cardType: null,
    acceptedTerms: false,
    firstName: null,
    lastName: null,
    email: null,
    digitalWallet: null,
    accountCredit: {
      credits: 0,
      payFull: false,
    },
    address: null,
    phone: null,
  };
  @Input() substractCreditsToBalance: number;
  @Input() showCreditsApplies: number;
  @Output() blurInputCredits = new EventEmitter();
  @Output() changeDigitalWalletSelector = new EventEmitter();
  @Output() checkboxPayInFullChange = new EventEmitter<Event>();
  @Output() addDigitalWalletClick = new EventEmitter();

  onBlurInputCredits() {
    this.blurInputCredits.emit();
  }

  onChangeDigitalWalletSelector() {
    this.changeDigitalWalletSelector.emit();
  }

  onCheckboxPayInFullChange(instance: Event) {
    this.checkboxPayInFullChange.emit(instance);
  }

  onAddDigitalWallet() {
    this.addDigitalWalletClick.emit();
  }
}
